import { createReducer, PayloadAction } from '@reduxjs/toolkit';

import {
    fetchProfileRequest,
    fetchProfileSuccess,
    fetchProfileFailure,
    editPasswordRequest,
    editPasswordSuccess,
    editPasswordFailure,
} from '@actions/profile';
import { User } from 'src/types/shared/User';

interface ProfileState {
    profile: User | null;
    isFetching: boolean;
    isPosting: boolean;
    editPasswordSuccess: boolean;
    fetchError: string | null;
    postError: string | null;
}

const initialState: ProfileState = {
    profile: null,
    isFetching: false,
    isPosting: false,
    editPasswordSuccess: false,
    fetchError: null,
    postError: null,
};

export default createReducer(initialState, {
    [fetchProfileRequest.type]: handleFetchRequest,
    [fetchProfileSuccess.type]: handleFetchSuccess,
    [fetchProfileFailure.type]: handleFetchFailure,
    [editPasswordRequest.type]: handlePostRequest,
    [editPasswordSuccess.type]: handleEditPasswordSuccess,
    [editPasswordFailure.type]: handlePostFailure,
});

function handleFetchRequest(state: ProfileState) {
    state.isFetching = true;
    state.fetchError = null;
}

function handleFetchSuccess(state: ProfileState, action: PayloadAction<User>) {
    state.isFetching = false;
    state.profile = action.payload;
}

function handleFetchFailure(state: ProfileState, action: PayloadAction<string>) {
    state.isFetching = false;
    state.fetchError = action.payload;
}

function handlePostRequest(state: ProfileState) {
    state.isPosting = true;
    state.editPasswordSuccess = false;
    state.postError = null;
}

function handleEditPasswordSuccess(state: ProfileState) {
    state.isPosting = false;
    state.editPasswordSuccess = true;
}

function handlePostFailure(state: ProfileState, action: PayloadAction<string>) {
    state.isPosting = false;
    state.postError = action.payload;
}
